import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";

@Component({
  selector: "sm-edit-access",
  templateUrl: "./edit-access.component.html",
  styleUrls: ["./edit-access.component.scss"],
})
export class EditAccessComponent implements OnInit, OnDestroy {
  functionalityList: any = [];
  apisub: Subscription;
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentdata: any,
    private ls: LoaderServiceService,
    private apiservice: ApiService,
    private activemodal: MatDialogRef<EditAccessComponent>
  ) {
    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_EMPLOYEE_FUNCTIONALITY_ACCESS_STATUS
      ) {
        if (resdata.result) {
          this.activemodal.close({msg : 'success'})
        }
      }
    });
  }

  ngOnInit(): void {
    this.functionalityList = JSON.parse(JSON.stringify(this.parentdata.data));
  }
  selectFunctionality(event: any, index: any) {
    this.functionalityList[index].access_status = event.checked == true ? 1 : 0;
  }

  onsave() {
    let obj = {
      employee_hash: this.parentdata.employeeHash,
      functionality_list: this.functionalityList.map((item: any) => {
        return {
          hash_id: item.hash_id,
          access_status: item.access_status,
        };
      }),
    };

    console.log(obj);

    this.ls.showLoader = true;
    this.apiservice.updateEmployeeFunctionalityAccessStatus(obj);
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe()
  }
}
